import { library } from "@fortawesome/fontawesome-svg-core";
import { faStore as fadStore } from "@fortawesome/pro-duotone-svg-icons";
import {
  faCheck as farCheck,
  faCheckSquare as farCheckSquare,
  faChevronDown as farChevronDown,
  faChevronLeft as farChevronLeft,
  faClipboardCheck as farClipboardCheck,
  faCoin as farCoin,
  faCreditCard as farCreditCard,
  faDollarSign as farDollarSign,
  faDownload as farDownload,
  faEnvelope as farEnvelope,
  faExchange as farExchange,
  faExchangeAlt as farExchangeAlt,
  faExclamationCircle as farExclamationCircle,
  faHandHoldingUsd as farHandHoldingUsd,
  faReceipt as farReceipt,
  faSackDollar as farSackDollar,
  faScroll as farScroll,
  faShoppingBag as farShoppingBag,
  faSignIn as farSignIn,
  faSignOut as farSignOut,
  faSmile as farSmile,
  faStoreSlash as farStoreSlash,
  faTachometerFast as farTachometerFast,
  faTimes as farTimes,
  faUsdCircle as farUsdCircle,
  faUser as farUser,
  faUsers as farUsers,
  faMoneyCheckEditAlt as farMoneyCheckEditAlt,
} from "@fortawesome/pro-regular-svg-icons";

import {
  faCheckSquare as fasCheckSquare,
  faChevronDown as fasChevronDown,
  faChevronRight as fasChevronRight,
  faFileChartLine as fasFileChartLine,
  faInfoCircle as fasInfoCircle,
} from "@fortawesome/pro-solid-svg-icons";

const initFontIcon = () => {
  library.add(
    fasChevronRight,
    fasInfoCircle,
    fasCheckSquare,
    fasFileChartLine,
    fadStore,
    farSignIn,
    farTimes,
    farExchangeAlt,
    farExchange,
    farTachometerFast,
    farShoppingBag,
    farSignOut,
    farUser,
    farScroll,
    farCreditCard,
    farReceipt,
    farExclamationCircle,
    farChevronLeft,
    farStoreSlash,
    farCheck,
    fasChevronDown,
    farChevronDown,
    farCoin,
    farCheckSquare,
    farUsers,
    farSackDollar,
    farUsdCircle,
    farHandHoldingUsd,
    farSmile,
    farClipboardCheck,
    farDollarSign,
    farEnvelope,
    farDownload,
    farMoneyCheckEditAlt
  );
};

export default initFontIcon;
